module.exports = __webpack_public_path__ + "files/db8398df4b62c6fab3eedca9e8f8f4f6.png";